<template>
  <DModal :show-close="false"
          :isBgOverlay="true"
          @close="close">
    <template slot="insertComponent">
      <div class="add-lesson__header">
        <h2>Opret klasse</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="close"><span
          class="icon-cross2"></span>
        </div>
      </div>
      <div class="add-lesson__form">
        <div class="input-group">
          <label>Klassenavn</label>
          <input type="text" v-model="klassebetegnelse" ref="inputTitle" @keyup.enter="submit">
        </div>
      </div>
      <div class="input-group input-group__submit">
        <div class="input-group__submit__left">
        </div>
        <div class="input-group__submit__right">
          <button class="marg-1-right bg-white" @click="close">{{ $t('vue2.common.cancel') }}</button>
          <div v-if="!isFormValid" class="hint--top-left" aria-label="Udfyld formularen">
            <button class="submit-button submit-button--disabled">Opret</button>
          </div>
          <button v-else class="submit-button" @click="submit">Opret</button>
        </div>
      </div>
    </template>
  </DModal>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import DModal from '../../common/DModal'

export default {
  components: {DModal},
  mixins: [clickaway],
  data () {
    return {
      klassebetegnelse: ''
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    isFormValid () {
      return this.klassebetegnelse.length > 0
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.isFormValid) {
        return
      }
      const uniqueId = `id_${new Date().getTime()}_${Math.random().toString(36).substr(2, 9)}`
      const klasse = {
        klassebetegnelse: this.klassebetegnelse,
        fag: [],
        hold: '',
        klasse_id: uniqueId,
        klasse_type: '',
        klassetrin: '',
        spor: ''

      }
      this.$emit('save', klasse)
    }
  },
  mounted () {
    this.$nextTick(_ => {
      this.$refs.inputTitle.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.add-lesson__form .d-table tbody tr td {
  width: auto !important;
}

.add-lesson__form .d-table tbody tr:nth-child(odd) {
  background: #fff;
}

input[type="number"] {
  max-width: 65px;
  padding: 0.5rem 0.75rem;
  text-align: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

select,
input[type="text"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 100px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
}

.d-table input[type="text"] {
  max-width: 40px;
}

.add-lesson__header {
  position: relative;
  transition: background-color 0.4s;
  padding: 30px 20px;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  background: #fff;
}

.add-lesson__header > h2 {
  margin-top: 0;
}

.add-lesson__form {
  position: relative;
  padding: 1rem 2rem;
  overflow-y: scroll;
  width: 450px;
  max-height: calc(100vh - 10vh - 120px); /* 120px is modal header; 10vh is modal from vtop */
}

.input-group {
  margin-top: 1rem;
}

.input-group label {
  margin-bottom: 0.5rem;
}

.input-group__submit {
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
  color: #3d4340;
  border-top: 1px solid #d8d8d8;
  background: #fff;
}

.input-group input,
.input-group select {
  background-color: #fff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
  width: 100%;
}

.input-group input:focus {
  border: 1px solid var(--purple);
}

.input-group__submit__right {
  display: flex;
}

.input-group__submit__right button {
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
}

.input-group label {
  letter-spacing: .075rem;
  text-transform: uppercase;
  font-size: .85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

</style>



// WEBPACK FOOTER //
// KompetenceIndberetningCreateKlasseModal.vue?d16e6414